/* OOTB Code
We have overridden this file to trigger an event after show more ajax success to re-init lazy load and animate up */

'use strict';

const baseSearch = require('base/search/search');
const { queryFirst, updateUrlQueryParam, addClass, removeClass, queryAll, scrollTo, hasClass, renderFragment, getCookieMap, debounce, setCookie, throttle } = require('../domUtil');
const { appendToUrl, formatMessage, getJSON, getNestedValue, isMobile, setUrlParamValue } = require('../util');
const { emptySwatchTemplate } = require('../templates');
const { HIDDEN_CLASS, INVISIBLE_CLASS, REFINEMENT_TYPE_CATEGORY, SELECTED_CLASS } = require('../constants');
const { enableAddAllToToteButton } = require('../product/helper');
const { getCookieDensityValue } = require('../productTiles/utils/gridDensity');
const { toggleSelectSizeInfo } = require('../product/helper');
const $window = $(window);
const $body = $('body');
const $container = $('.container');
const $searchResultsContainer = $('.search-results.container');
const $filtersBarContainer = $('.search-results-container');
const $refinementBar = $('.refinement-bar');
const $modalBG = $('.modal-background');
const REFINEMENTS_CONTAINER_SELECTOR = '.refinements-container';
const { lp_hsc_enabled: akamaiEnabled, lp_hsc_category: plpCaching, lp_cache_hash: lpCacheHash, lp_group_hash: lpGroupHash } = getCookieMap();
const isAkamaiEnabled = akamaiEnabled === 'true' && plpCaching && lpCacheHash && lpGroupHash;
const akamaiSettings = (queryFirst('#akamai-settings') || { dataset: {} }).dataset;
const hideBtnMobile = queryFirst('.hide-mobile-filter-btn');
const hideClass = 'hidden-filters';
const showMoreRefinementClass = '.show-more-refinement';
const plpFiltersBar = queryAll('.js-plp-filters');
let cacheSyncTimer;
const observedTargets = new Set();
let tileToScroll;
let isDensityButtonClicked;
let preventObserver = false;

/**
 * Function that updates action url after every ajax call
 * @param {string} actionUrl action url
 */
function updateRefinementsAjaxUrl(actionUrl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    refinementsContainer.dataset.actionUrl = actionUrl;
}

/**
 * Append Store filter params to action Url
 * @param {HTMLElement} element the element which triggered the filter
 * @param {string} actionUrl action url
 * @returns {string} updated action url
 */
function appendStoreFilterQueryParams(element, actionUrl) {
    // If event is triggered on storeToggle Checkbox, then proceed with url updation
    let storeToggleEl = element;
    if (element?.dataset?.refinementType === REFINEMENT_TYPE_CATEGORY) {
        // If event is triggered on refinement category, then find the storeToggle checkbox
        storeToggleEl = queryFirst('.store-filter-toggle');
    }
    if (hasClass(storeToggleEl, 'store-filter-toggle')) {
        const STORE_ID_PARAM = 'storeID';
        const { storeId } = storeToggleEl.dataset;

        // Updating relative URL query params using URL api
        const url = new URL(location.origin + actionUrl);
        const { searchParams } = url;
        if (storeToggleEl.checked) {
            searchParams.set(STORE_ID_PARAM, storeId);
        } else {
            searchParams.delete(STORE_ID_PARAM);
        }
        url.search = searchParams.toString();

        // url.pathname -> "/on/demandware.store/Sites-lillypulitzer-sfra-Site/default/Search-ShowAjax"
        // url.search -> "?cgid=dresses-1-all&prefn1=refinementCategoryDresses&prefv1=Shift%7cA-Line%2fEasy%7cStraight"
        return url.pathname + url.search;
    }
    return actionUrl;
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {string} - Selected sort.
 */
function updateSortOptions(fragment) {
    const toggleEls = queryAll('.sort-order-menu-toggle span');
    const gridFooter = queryFirst('.grid-footer', fragment);

    if (gridFooter && toggleEls.length) {
        const dataSortLabel = gridFooter.dataset.sortLabel;
        toggleEls.forEach(toggleEl => {
            toggleEl.textContent = dataSortLabel;
        });

        const { options: sortOptions, ruleId: selectedRule } = JSON.parse(gridFooter.dataset.sortOptions);

        sortOptions.forEach(function (option) {
            const $sortOption = $('.sort-order-menu-dropdown button[data-id="' + option.id + '"], button[data-id="' + option.id + '"].sort-order-menu-option');
            $sortOption.val(option.url);
            if (option.ruleId === selectedRule) {
                $sortOption.addClass('selected');
                $sortOption.attr('aria-selected', 'true');
                toggleEls.forEach(toggleEl => {
                    toggleEl.textContent = option.displayName;
                });
            } else {
                $sortOption.removeClass('selected');
                $sortOption.attr('aria-selected', 'false');
            }
        });
    }
    return toggleEls && toggleEls[0] ? toggleEls[0].textContent : '';
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom(fragment, selector) {
    const containers = queryAll(selector);
    const updates = queryFirst(selector, fragment);

    if (containers.length && updates) {
        containers.forEach(container => {
            const clone = updates.cloneNode(true);

            container.parentElement.replaceChild(clone, container);
        });
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function handleRefinements(fragment) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = queryFirst('.' + $(this)[0].className.replace(/ /g, '.'), fragment);
        addClass(activeDiv, 'active');
        queryFirst('button.title', activeDiv).setAttribute('aria-expanded', 'true');
    });
    // show category in filter bar only in case if cgid!=selected refinement ID
    if (queryFirst('.category-id', fragment)?.value !== queryFirst('.js-parent-category')?.dataset.refinementId) {
        removeClass(queryFirst('.js-category-refinement', fragment), HIDDEN_CLASS);
    }

    queryAll(showMoreRefinementClass, fragment)?.forEach(element => {
        if (!queryFirst(`li.${HIDDEN_CLASS}`, element.parentElement)) {
            addClass(element, HIDDEN_CLASS);
        }
    });

    scrollTo(0, 0);
    updateDom(fragment, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 */
function parseResults(fragment) {
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    ['.grid-header', '.header-bar', '.header.page-title', '.product-grid', '.show-more', '.filter-bar', '.store-filter-container', '.js-productsearch-footer'].forEach(function (selector) {
        updateDom(fragment, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector](fragment);
    });
}

/**
 * Update Category refinement
 * @param {Element} element selected element
 */
function updateCategoryRefinemnts(element) {
    if (!element) return;
    removeClass(queryAll('.selected', element.closest('.subcategory-refinement-bar')), SELECTED_CLASS);
    addClass(element, SELECTED_CLASS);
    addClass(queryFirst('.refinement-text', element), SELECTED_CLASS);
}

/**
 * Update search results count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {number} Returns the total number of search results
 */
function updateCount(fragment) {
    const productCount = queryFirst('.current-product-count', fragment);
    const resultCounts = queryAll('.result-count');

    if (!productCount) {
        const noFilterResults = queryFirst('.no-filter-results', fragment);

        if (noFilterResults) {
            resultCounts.forEach(item => {
                item.textContent = noFilterResults.dataset.noproductcount;
            });
        }
    } else {
        resultCounts.forEach(item => {
            item.textContent = productCount.value;
        });
        const productCountTextFragment = queryFirst('.result-text', fragment);
        if (productCountTextFragment) {
            queryAll('.result-text').forEach(item => {
                const clone = productCountTextFragment.cloneNode(true);
                item.textContent = clone.innerHTML;
            });
        }
    }

    const container = queryFirst('.no-filter-results');
    const resultCountsText = getNestedValue(resultCounts, '[0].innerText');

    if (container) {
        const resultCountsDigits = resultCountsText && resultCountsText.replace(/\D/g, '');
        const numOfProducts = parseInt(resultCountsDigits, 10);

        if (numOfProducts > 0) {
            addClass(container, HIDDEN_CLASS);
        } else {
            removeClass(container, HIDDEN_CLASS);
        }
    }

    return parseInt(((resultCountsText && resultCountsText.split(' of ')[1]) || '0').replace(/\D/g, ''), 10);
}

/**
 * remove hidden class 'd-none' for selected filter count
 */
function removeHiddenClassForSelectedCount() {
    const hiddenFilterCountElements = queryAll('.selected-filter-count.' + HIDDEN_CLASS);
    if (hiddenFilterCountElements) removeClass(hiddenFilterCountElements, HIDDEN_CLASS);
}

/**
 * determines if storePickUp filter is checked
 * @returns {boolean} checked/unchecked
 */
function isStorePickUpChecked() {
    return queryFirst('.store-filter-toggle')?.checked;
}

/**
 * add store pickup filter to the filter counter
 */
function addStorePickUpToFilterCounter() {
    if (!isStorePickUpChecked()) return;

    const searchResultContainer = queryFirst('.search-results.container');
    const selectedFilterCounts = queryAll('.js-selected-filter-count', searchResultContainer);
    selectedFilterCounts.forEach(selectedFilterCount => {
        if (selectedFilterCount && selectedFilterCount.innerText) {
            selectedFilterCount.innerText = parseInt(selectedFilterCount.innerText, 10) + 1;
        }
    });
    removeHiddenClassForSelectedCount();

    // add store pickUp to the 'filter counter' for the extra 'filter counter field' on mobile
    const filterCountMobile = isMobile() && queryFirst('.js-filter-count-mobile', searchResultContainer);
    if (filterCountMobile && filterCountMobile.innerText) {
        filterCountMobile.innerText = parseInt(filterCountMobile.innerText, 10) + 1;
    }
}

/**
 * Update filter count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updateFilterCount(fragment) {
    const filterCountWrapper = queryFirst('.selected-filter-count', fragment);
    const filterCount = queryFirst('.js-selected-filter-count', fragment);
    const productCount = queryFirst('.no-filter-results', fragment);
    const resetFilterBtnFragment = queryFirst('.js-clear-filters-btn', fragment);
    const resetFilterBtns = queryAll('.js-clear-filters-btn');
    const searchResultContainer = queryFirst('.search-results.container');
    const selectedFilterCounts = queryAll('.js-selected-filter-count', searchResultContainer);
    const showFilterSortHeader = queryFirst('.show-filter-sort-header', searchResultContainer);
    const displayClass = 'd-md-flex';

    if (filterCountWrapper) {
        if (!selectedFilterCounts.length) {
            queryAll('.js-filter-text', searchResultContainer).forEach(filterText => {
                // Clone the filterCountWrapper element to ensure a new one is inserted each time
                const clone = filterCountWrapper.cloneNode(true);
                if (filterText.nextSibling) {
                    filterText.parentNode.insertBefore(clone, filterText.nextSibling);
                } else {
                    filterText.parentNode.appendChild(clone);
                }
            });
        } else {
            selectedFilterCounts.forEach(selectedFilterCount => {
                const clone = filterCount.cloneNode(true);
                selectedFilterCount.replaceWith(clone);
            });
        }
    } else {
        selectedFilterCounts.forEach(selectedFilterCount => {
            selectedFilterCount.closest('.selected-filter-count').remove();
        });
    }

    queryAll('.js-hide-filter', searchResultContainer).forEach(filterBtn => {
        if (resetFilterBtnFragment && !resetFilterBtns.length) {
            const clone = resetFilterBtnFragment.cloneNode(true);
            if (filterBtn.nextSibling) {
                filterBtn.parentNode.insertBefore(clone, filterBtn.nextSibling);
            } else {
                filterBtn.parentNode.appendChild(clone);
            }
        } else if (resetFilterBtns.length && !resetFilterBtnFragment) {
            resetFilterBtns.forEach(resetFilterBtn => {
                resetFilterBtn.remove();
            });
        }
    });

    // This will show/hide desktop filter and sorting fillter in desktop if product count is zero
    if (!productCount || productCount.dataset.productcount !== '0') {
        addClass(showFilterSortHeader, displayClass);
    } else {
        removeClass(showFilterSortHeader, displayClass);
    }

    addStorePickUpToFilterCounter();
}

/**
 * Update show no results message
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function showNoResultsText(fragment) {
    const noFilterResults = queryFirst('.no-filter-results', fragment);
    if (noFilterResults) {
        const numOfProducts = parseInt(noFilterResults.dataset.productcount, 10);

        if (numOfProducts > 0 && !noFilterResults.classList.contains(HIDDEN_CLASS)) {
            noFilterResults.classList.add(HIDDEN_CLASS);
        } else {
            noFilterResults.classList.remove(HIDDEN_CLASS);
        }

        const container = queryFirst('.no-filter-results');

        if (container) container.parentElement.replaceChild(noFilterResults, container);
    } else {
        console.error('Could not find element in filter results fragment'); // eslint-disable-line no-console
    }
}

/**
 * Update Page Title, Description and Canonical URL with color filter
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
const updatePageTitle = fragment => {
    const pageTitle = queryFirst('.seo-page-title', fragment);
    const pageDescription = queryFirst('.seo-page-description');
    const canonicalUrl = queryFirst('.canonical-url');

    if (pageTitle) document.title = pageTitle.value;

    if (pageDescription) {
        const metaTag = queryFirst('meta[name="description"]');

        if (metaTag) metaTag.setAttribute('content', pageDescription.value);
    }

    if (canonicalUrl) {
        const canonLink = queryFirst('link[rel="canonical"]');

        if (canonLink) canonLink.setAttribute('href', canonicalUrl.value);
    }
};

/**
 * Update plp filters swatch images
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updatePatternImageSwatch(fragment) {
    const refinementPatterns = queryFirst('#refinement-print--pattern-and-solid', fragment);

    if (!refinementPatterns) return;

    const imgItems = queryAll('.refinement-image', refinementPatterns);

    imgItems.forEach(imageEl => {
        const { src, srcset } = imageEl.dataset;

        imageEl.src = src;

        if (srcset) imageEl.srcset = srcset;

        removeClass(imageEl, INVISIBLE_CLASS);
        imageEl.onload = () => addClass(imageEl, 'image-loaded');
    });

    const container = queryFirst('#refinement-print--pattern-and-solid');

    if (container) container.parentElement.replaceChild(refinementPatterns, container);
}

/**
 * Updates PLP products with out of stock text where applicable.
 * @param {Object} staleProductIds - A plain object of variation group IDs / inStock status
 */
function updateProducts(staleProductIds) {
    if (!staleProductIds || Object.keys(staleProductIds).length === 0) return;

    const productGrid = queryFirst('.product-grid');
    const currentProductIds = queryAll('.product', productGrid)
        .map(node => node.dataset.pid)
        .filter(Boolean);

    if (currentProductIds.length === 0) return;

    const oosProducts = Object.keys(staleProductIds).filter(productId => !staleProductIds[productId]);
    const { outOfStockMessage = '' } = productGrid.dataset;
    const oosClass = 'out-of-stock';

    oosProducts.forEach(productId => {
        const node = queryFirst(`.product[data-pid="${productId}"]`, productGrid);
        if (!node || node.classList.contains(oosClass)) return;

        const numSwatches = queryAll('.color-swatches button', node).length;
        // If there are multiple swatches, we don't know whether those are OOS too.
        if (numSwatches > 1) return;

        node.classList.add(oosClass);

        // If there's just 1 swatch, mark it as Sold Out.
        const swatches = queryFirst('.color-swatches .swatches', node);
        if (swatches) swatches.innerHTML = formatMessage(emptySwatchTemplate, outOfStockMessage);
    });
}

/**
 * check if it is the last selected refinement in the group
 * and get current group id
 * @param {Object} element dom element
 *  @returns {string|boolean} current filter/refinement group id
 */
function getCurrentFilterGroup(element) {
    if (!hasClass(element, 'selected')) return false;

    const $jsRefinement = $(element).closest('.js-refinement');
    const isLastSelectedRefinement = $jsRefinement.find('.js-refinement-content li button.selected').length === 1;
    const isSizeRefinement = $jsRefinement.hasClass('js-size-refinements');

    // check if it is the last selected element
    // check if it is 'size' refinement, because there may be selected multiple sizes after one click
    return (isLastSelectedRefinement || isSizeRefinement) && $jsRefinement.data('filter-group-id');
}

/**
 * show refinements for the current group
 * if there is currentRefinementGroup obtained from getCurrentFilterGroup()
 * @param {string} currentRefinementGroup data-filter-group-id
 */
function showRefinementContent(currentRefinementGroup) {
    const jsRefinement = queryFirst('.js-refinement[data-filter-group-id="' + currentRefinementGroup + '"]');
    const jsRefinementContent = jsRefinement && queryFirst('.js-refinement-content', jsRefinement);

    if (jsRefinementContent && !hasClass(jsRefinementContent, 'show')) {
        addClass(jsRefinementContent, 'show');

        const jsShowFilterBtn = queryFirst('.js-show-filter-btn', jsRefinement);
        if (jsShowFilterBtn) {
            removeClass(jsShowFilterBtn, 'collapsed');
            jsShowFilterBtn.setAttribute('aria-expanded', 'true');
        }
    }
}

/**
 *
 * @param {Object} element dom element
 * @param {string} actionUrl action url
 */
function getResultsOnPriceFilter(element, actionUrl) {
    const prevActionUrl = actionUrl;
    let updatedActionUrl = appendStoreFilterQueryParams(element, actionUrl);
    updatedActionUrl = setUrlParamValue(updatedActionUrl, 'density', getCookieDensityValue());
    const akamaiActionUrl = isAkamaiEnabled
        ? appendToUrl(updatedActionUrl, {
            'lp-cache-hash': lpCacheHash,
            'lp-group-hash': lpGroupHash
        })
        : updatedActionUrl;
    const gridFooter = queryFirst('.grid-footer');
    const pageNumber = (gridFooter && gridFooter.dataset.pageNumber) || 0;
    const currentRefinementGroup = getCurrentFilterGroup(element);
    const refinementType = element.dataset?.refinementType;

    $.ajax({
        url: akamaiActionUrl,
        data: {
            page: pageNumber,
            selectedUrl: akamaiActionUrl
        },
        success: function (response, status, xhr) {
            const serverTiming = xhr.getResponseHeader('server-timing') || '';
            const isCached = !!(serverTiming && serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

            if (hasClass(element, 'clear-filters-btn') && $('.no-filter-results').attr('data-productcount') === '0') {
                $('.store-filter-toggle').prop('checked', false);
            }
            updateRefinementsAjaxUrl(prevActionUrl);

            const fragment = renderFragment(response);

            updateUrlQueryParam(fragment);
            parseResults(fragment);
            updateSortOptions(fragment);
            updatePageTitle(fragment);
            showNoResultsText(fragment);
            if (refinementType === REFINEMENT_TYPE_CATEGORY) {
                updateCategoryRefinemnts(element);
            }

            const productCount = updateCount(fragment);

            updateFilterCount(fragment);
            updatePatternImageSwatch(fragment);

            const container = queryFirst('.no-filter-results');
            if (container) {
                if ($('.no-filter-results').attr('data-productcount') !== '0') {
                    addClass(container, HIDDEN_CLASS);
                } else {
                    removeClass(container, HIDDEN_CLASS);
                }
            }
            $body.trigger('search:updateProducts', element); // LP custom changes end

            // Check Akamai cache
            if (isCached) {
                const cacheKey = encodeURIComponent(xhr.getResponseHeader('x-cache-key'));
                const productIds = queryAll('.product-grid .product')
                    .map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`)
                    .filter(Boolean)
                    .join(',');
                const syncUrl = akamaiActionUrl.replace('ShowAjax', 'SyncShowAjax');

                clearTimeout(cacheSyncTimer);

                cacheSyncTimer = setTimeout(() => {
                    getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                        if (data.stale) {
                            // Update products with fresh stock status if we can
                            updateProducts(data.staleProductIds);

                            if (data.cacheInvalidated) {
                                // Akamai takes about 5 seconds to clear an entry
                                // Once that's complete, we should rebuild the cache with a fresh request
                                setTimeout(() => {
                                    $.ajax({
                                        url: akamaiActionUrl,
                                        data: {
                                            page: pageNumber,
                                            selectedUrl: akamaiActionUrl
                                        }
                                    });
                                }, akamaiSettings.cacheRefreshDelay);
                            }
                        }
                    });
                }, akamaiSettings.cacheSyncDelay);
            }

            if (currentRefinementGroup) showRefinementContent(currentRefinementGroup);

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * return Akamai action url
 * @param {string} showMoreUrl link for products load
 * @returns {string} updated link
 */
function getAkamaiActionUrl(showMoreUrl) {
    return isAkamaiEnabled
        ? appendToUrl(showMoreUrl, {
            'lp-cache-hash': lpCacheHash,
            'lp-group-hash': lpGroupHash
        })
        : showMoreUrl;
}

/**
 *
 * @param {string} showMoreUrl URL used to fetch new products
 * @param {Object} e Event causing this update
 * @param {boolean} isPagination Boolean true if this is a pagination-based update; false if "Show More"
 * @param {boolean} isBackButton true if loading because of a back button click; false otherwise. Avoids pushing duplicate history entries.
 * @param {observerObj} observerObj Observe object
 * @param {boolean} isPrevious true in case of load produts from end to starts
 */
function loadProducts(showMoreUrl, e, isPagination, isBackButton = false, observerObj = {}, isPrevious = false) {
    $.spinner().start();

    // save a Density clicked status before several AJAX requests,
    // to avoid issues related to a call loadProducts() from 'popstate' event and initialiseSearchIntersection()
    let savedDensityClickState;
    if (isDensityButtonClicked) {
        savedDensityClickState = true;
        isDensityButtonClicked = false;
    }

    $body.trigger('search:showMore', e);

    if (isPagination) {
        // scrolling to top before the new products are added to the page allows the lazy loader to be more effective
        const plpHeader = queryFirst('.clp-results-header');
        const mainHeader = queryFirst('.main-header');
        scrollTo(plpHeader && mainHeader ? plpHeader.offsetTop - mainHeader.offsetHeight : 0);
    }

    const akamaiActionUrl = getAkamaiActionUrl(showMoreUrl);
    $.ajax({
        url: akamaiActionUrl,
        data: { selectedUrl: akamaiActionUrl },
        success: (response, status, xhr) => {
            const headers = {
                serverTiming: xhr.getResponseHeader('server-timing') || '',
                xCacheKey: xhr.getResponseHeader('x-cache-key')
            };
            if (isPrevious) {
                const grid = queryFirst('.js-product-grid');
                if (!tileToScroll) {
                    tileToScroll = queryFirst('.product', grid);
                }
            }
            getProductsCallBack(headers, akamaiActionUrl, response, isPagination, isBackButton, isPrevious, savedDensityClickState);

            scrollToTile();
            $.spinner().stop();
            preventObserver = false;
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Callback for updating PLP
 * @param {Object} headers response headers
 * @param {string} akamaiActionUrl akamai link
 * @param {Object} response Response object
 * @param {boolean} isPagination Boolean true if this is a pagination-based update; false if "Show More"
 * @param {boolean} isBackButton true if loading because of a back button click; false otherwise. Avoids pushing duplicate history entries.
 * @param {boolean} isPrevious true in case of load produts from end to starts
 * @param {boolean} isDensityChange determines if it is a density change event
 */
function getProductsCallBack(headers, akamaiActionUrl, response, isPagination, isBackButton, isPrevious, isDensityChange) {
    const isCached = !!(headers.serverTiming && headers.serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

    if (isPagination) {
        $('.product-grid').html(response);
    } else if (isPrevious) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response, 'text/html');
        const footer = queryFirst('.grid-footer', doc);
        queryFirst('.js-show-previous').dataset.url = queryFirst('.js-show-previous', doc)?.dataset.url || '';
        if (footer) {
            footer.remove();
        }

        addClass(queryAll('.product-tile-container, .category-marketing-slot', doc), HIDDEN_CLASS);

        const targetDiv = queryFirst('.js-product-grid .product-tile-container');

        targetDiv.insertAdjacentHTML('beforebegin', doc.body.innerHTML);

        removeClass(queryAll('.product-tile-container, .category-marketing-slot'), HIDDEN_CLASS);
        updateSlotsMarkup();
    } else {
        const prevElementLink = queryFirst('.js-show-previous')?.dataset.url || '';

        $('.grid-footer').replaceWith(response);

        const updatedPrevElement = queryFirst('.js-show-previous');
        if (updatedPrevElement) {
            updatedPrevElement.dataset.url = prevElementLink;
        }

        updateSlotsMarkup();
    }

    const fragment = renderFragment(response);

    updateSortOptions(fragment);
    // LP custom changes start
    if (!isBackButton && !isPrevious) {
        // Pagination: don't update querystring on back button click -- otherwise user gets stuck after the fist time they click back due to a new history entry being pushed
        updateUrlQueryParam(fragment);
    }

    const productCount = updateCount(fragment);

    // send isDensityChange flag to analytics event VIEW_SEARCH_RESULTS
    $body.trigger('search:updateProducts', { isDensityChange: isDensityChange });

    // Check Akamai cache
    if (isCached) {
        const cacheKey = encodeURIComponent(headers.xCacheKey);
        const gridFooter = queryFirst('.grid-footer', fragment);
        const pageSize = (gridFooter && parseInt(gridFooter.dataset.pageSize, 10)) || 48;
        const productIds = queryAll('.product-grid .product')
            .slice(-pageSize)
            .map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`)
            .filter(Boolean)
            .join(',');
        const syncUrl = akamaiActionUrl.replace('UpdateGrid', 'SyncUpdateGrid');

        clearTimeout(cacheSyncTimer);

        cacheSyncTimer = setTimeout(() => {
            getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                if (data.stale) {
                    // Update products with fresh stock status if we can
                    updateProducts(data.staleProductIds);

                    if (data.cacheInvalidated) {
                        // Once that's complete, we should rebuild the cache with a fresh request
                        setTimeout(() => {
                            $.ajax({
                                url: akamaiActionUrl,
                                data: {
                                    selectedUrl: akamaiActionUrl
                                }
                            });
                        }, akamaiSettings.cacheRefreshDelay);
                    }
                }
            });
        }, akamaiSettings.cacheSyncDelay);
    }
}

/**
 * Method to initialise the  intersection observer
 *
 */
baseSearch.initialiseSearchIntersection = () => {
    if (!queryFirst('.js-infinite-scroll-enabled')) {
        return;
    }
    const observerTargetNext = queryFirst('#footercontent');
    const observerTargetPrev = queryFirst('.page-title.plp-title');
    const deltaTop = observerTargetNext.getBoundingClientRect().top - queryFirst('.grid-footer').getBoundingClientRect().top + 100;

    const optionsNext = {
        rootMargin: `${Math.ceil(deltaTop)}px 0px`,
        threshold: 0.01
    };
    const optionsPrev = {
        rootMargin: '200px 0px',
        threshold: 0.01
    };

    /**
     * Represents a callback function which will be called when the observed target element enters the viewport
     * @param {Array} entries IntersectionObserverEntry Objects
     */
    function handleIntersect(entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                if (preventObserver) {
                    return false;
                }
                let targetURL = queryFirst('.show-more button')?.dataset.url;
                let isPrevious = false;
                if (entry.target === observerTargetPrev) {
                    targetURL = queryFirst('.js-show-previous')?.dataset.url;
                    isPrevious = true;
                }

                if (!targetURL) return;
                preventObserver = true;
                const infiniteScrollEvent = new Event('infiniteScrollEvent');
                const observerObj = {
                    target: entry.target
                };
                loadProducts(targetURL, infiniteScrollEvent, false, false, observerObj, isPrevious);
            }
        });
    }
    let observerNext = new IntersectionObserver(handleIntersect, optionsNext);
    let observerPrev = new IntersectionObserver(handleIntersect, optionsPrev);

    // Safely observe the initial targets
    if (observerTargetNext) {
        if (!observedTargets.has(observerTargetNext)) {
            observerNext.observe(observerTargetNext);
            observedTargets.add(observerTargetNext);
        }
    }
    if (observerTargetPrev) {
        if (!observedTargets.has(observerTargetPrev)) {
            observerPrev.observe(observerTargetPrev);
            observedTargets.add(observerTargetPrev);
        }
    }
}

/**
 * Function to apply store filter on PLP page
 * @param {HTMLElement} checkboxToggleEl Store filter toggle checkbox element
 * @param {boolean} appendStoreID Flag to append storeID to URL params
 */
function applyStoreFilter(checkboxToggleEl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    const { actionUrl } = refinementsContainer.dataset;

    // Perform Filter
    $.spinner().start();
    getResultsOnPriceFilter(checkboxToggleEl, actionUrl);
}

/**
 * update 'productInfo' and 'productInventory' from quickviewProductInfo data
 * @param {Object} quickviewProductInfo productInfo data
 */
function updateProductInfoFromQuickViewInfo(quickviewProductInfo) {
    const { productInfo, productInventory } = quickviewProductInfo;
    if (!productInfo || !productInventory || !productInfo.length || !productInventory.length) return;

    if (!window.productInfo) window.productInfo = {};
    for (let i = 0, n = productInfo.length; i < n; i++) {
        let productData = productInfo[i];
        window.productInfo[productData.id] = productData.data;
    }

    if (!window.productInventory) window.productInventory = {};
    for (let i = 0, n = productInventory.length; i < n; i++) {
        let productInventoryData = productInventory[i];
        window.productInventory[productInventoryData.id] = productInventoryData.data;
    }
}

/**
 * Update The filter count if storefilter is applied on load
 */
$(function () {
    const noResultsRecommendationPage = queryFirst('.no-results-recommendations');
    const noFilterResults = queryFirst('.no-filter-results');
    const refinementPrice = queryFirst('.refinement-price');

    if (refinementPrice) {
        const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
        const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;

        if ((minPrice || maxPrice) && noResultsRecommendationPage) {
            addClass(noResultsRecommendationPage, HIDDEN_CLASS);
        }
    }

    addStorePickUpToFilterCounter();

    // On page reload or category change, if products are available
    // hide the clear filter (no results section)

    if (noFilterResults) {
        const numOfProducts = noFilterResults.dataset.productcount;
        if (numOfProducts > 0) {
            addClass(noFilterResults, HIDDEN_CLASS);
        } else {
            removeClass(noFilterResults, HIDDEN_CLASS);
        }
    }
});

baseSearch.showMore = function () {
    const productGrid = queryFirst('.product-grid');
    const pagination = queryFirst('.pagination', productGrid);
    // Show more, traditional, and new pagination link event to load new products
    $container.on('click', '.show-more button, .product-grid .pagination a', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const { url } = this.dataset;

        if (!url) return;

        loadProducts(url, e, !!pagination);
    });

    if (pagination) {
        const { getNestedValue } = require('../util');

        if (hasClass(pagination, 'new-pagination')) {
            $container.on('change', '.pagination-pages', e => {
                e.stopPropagation();
                loadProducts(getNestedValue(e, 'target.selectedOptions[0].dataset.url'), e, true);
            });
        }

        window.addEventListener('popstate', e => {
            const baseUrlElem = queryFirst('.ajax-base-url');
            const baseUrlWithParams = baseUrlElem && baseUrlElem.value;
            const baseUrl = baseUrlWithParams && new URL(baseUrlWithParams);
            const baseParams = baseUrl && new URLSearchParams(baseUrl.search);
            const qsParams = getNestedValue(e, 'state.path');

            if (qsParams) {
                const newParams = new URLSearchParams(qsParams.split('?')[1]);
                newParams.forEach((value, key) => {
                    baseParams.set(key, value);
                });
            }

            const finalUrl = baseUrl.origin + baseUrl.pathname + '?' + baseParams.toString();
            loadProducts(finalUrl, e, true, true);
        });
    }
};

baseSearch.applyFilter = function () {
    /**
     * Applying refinements
     * @param {Element} e event element
     */
    function onRefinement(e) {
        const { dataset } = this;
        if (hasClass(this, 'close-filters-btn')) {
            hideRefinements();
        }

        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(this).trigger('search:filter', e);
        const actionUrl = dataset.href || dataset.actionUrl;
        getResultsOnPriceFilter(this, actionUrl);
    }

    // Handle refinement value selection and reset click
    $container.on('click', '.refinements li button, .search-results-container button.reset, .filter-value button.clear-filters-btn, .swatch-filter button, .subcategory-refinement-bar li button, .store-filter-container li button', onRefinement);

    // Prevent checkbox/toggle change is store id attribute is not present
    $container.on('click', '.store-filter-toggle', event => {
        if (!event.target.dataset.storeId) {
            event.preventDefault();
        }
    });

    // Toggle checkbox change event
    $container.on('change', '.store-filter-toggle', event => {
        applyStoreFilter(event.target);
    });

    // Selecting a store from the drawer
    $searchResultsContainer.on('filter:updateStoreId', (_e, data) => {
        // Updating new storeId on DOM
        const storeFilterToggleEl = queryFirst('.store-filter-toggle');
        const { storeId, storeName, storeCity, storeStateCode } = data;

        if (storeId) {
            // Updating toggle data attrs and state
            storeFilterToggleEl.dataset.storeId = storeId;
            storeFilterToggleEl.dataset.storeName = storeName;
            storeFilterToggleEl.checked = true;

            window.lillyUtils.shippingPreferencesConfig.storeId = storeId;

            // Updating Change store link
            const buttonLabel = `${storeName || ''} - ${storeCity || ''}, ${storeStateCode}`;
            const storeSelectorEl = queryFirst('.btn-in-store-pickup');
            if (storeSelectorEl) {
                storeSelectorEl.textContent = buttonLabel;
            }

            // Apply a store filter
            applyStoreFilter(storeFilterToggleEl);
        }
    });
    // Allow store filter to be seen / clicked now that the event handler is in place
    /** @type {HTMLInputElement} */
    const storeFilterToggle = queryFirst('.store-filter .switch');
    if (storeFilterToggle) {
        removeClass(storeFilterToggle, INVISIBLE_CLASS);
    }
};

/**
 * Update query params and triger search for price refinement
 * @param {Object} e Event causing this update
 * @return {undefined} undefined if it is not submit event
 */
function refineByPrice(e) {
    const refinementPrice = queryFirst('.refinement-price');
    const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
    const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;
    const priceForm = queryFirst('.price-filter-form', refinementPrice);
    const applyButton = queryFirst('.price-apply-button', refinementPrice);
    const uri = priceForm.dataset.href;
    e.preventDefault();
    e.stopPropagation();

    const errorMsg = queryFirst('.js-price-filter-error-msg', refinementPrice);
    if (minPrice && maxPrice && parseInt(minPrice, 10) < parseInt(maxPrice, 10)) {
        addClass(errorMsg, HIDDEN_CLASS);
        applyButton.disabled = false;

        if (e.type !== 'submit') return;
        $.spinner().start();
        const searchParams = new URLSearchParams(uri);
        searchParams.set('pmin', parseInt(minPrice, 10));
        searchParams.set('pmax', parseInt(maxPrice, 10));
        const newUrl = decodeURIComponent(searchParams.toString());

        priceForm.dataset.href = newUrl;
        $(this).trigger('search:filter', e);
        getResultsOnPriceFilter(priceForm, newUrl);
    } else if (minPrice && maxPrice) {
        removeClass(errorMsg, HIDDEN_CLASS);
        applyButton.disabled = true;
    }
}

baseSearch.updatePrice = function () {
    $container.on('click', '.refinement-price .values button', () => {
        addClass(queryFirst('.values button', queryFirst('.refinement-price')), 'is-not-custom');
    });
    $container.on('focus', '.refinement-price input', () => {
        removeClass(queryFirst('.price-filter', queryFirst('.refinement-price')), 'is-not-custom');
    });

    // prevent negative value
    $container.on('keydown', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', e => {
        if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 13)) {
            return false;
        }
    });

    $container.on('submit', '.price-filter-form', refineByPrice);
    $container.on('keyup', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', refineByPrice);
};

/**
 * Show the filter refinements UI
 */
function showRefinements() {
    $filtersBarContainer.removeClass(hideClass);
    $modalBG.show();
    $body.addClass('modal-open');
    $(hideBtnMobile).trigger('toggle.lp.filters', 'filter menu: show');
    $refinementBar.siblings().attr('aria-hidden', true);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
    $refinementBar.find('.close').trigger('focus');
}

/**
 * Hide the filter refinements UI
 */
function hideRefinements() {
    $filtersBarContainer.addClass(hideClass);
    $modalBG.hide();
    $body.removeClass('modal-open');
    $(hideBtnMobile).trigger('toggle.lp.filters', 'filter menu: show');
    $refinementBar.siblings().attr('aria-hidden', false);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
}

baseSearch.filter = function () {
    // Display refinements bar when Menu icon clicked
    $container.on('click', 'button.filter-results', function () {
        showRefinements();
    });
};

baseSearch.closeRefinements = function () {
    // Refinements close button
    $container.on('click', '.refinement-bar button.close, .refinement-bar button.close-filters-btn', function () {
        hideRefinements();

        const filterResults = queryFirst('.filter-results');

        if (filterResults) filterResults.focus();
    });

    $body.on('click', '.modal-background', function () {
        hideRefinements();

        const filterResults = queryFirst('.filter-results');

        if (filterResults) filterResults.focus();
    });
};

baseSearch.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $window.on('resize', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
            $body.removeClass('modal-open');
            $modalBG.hide();
        } else {
            hideRefinements();
        }
    });
};

baseSearch.backToTop = function () {
    const backToTopButton = queryFirst('.back-to-top-icon');
    if (backToTopButton) {
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 2200 || document.documentElement.scrollTop > 2200) {
                backToTopButton.style.display = 'block';
            } else {
                backToTopButton.style.display = 'none';
            }
        });

        backToTopButton.addEventListener('click', () => {
            scrollTo(0, 600, function () {
                return;
            });
        });
    }
};

baseSearch.sortHandler = function () {
    const selectedOption = queryFirst('.js-selected-sort-option');

    $body.on('search:sortOptions', function (e, data) {
        const { response } = data;
        const fragment = renderFragment(response);

        updateUrlQueryParam(fragment);
        parseResults(fragment);
        const sortText = updateSortOptions(fragment);
        selectedOption.innerText = sortText;
        showNoResultsText(fragment);
        updateCount(fragment);
        updateFilterCount(fragment);
        updatePatternImageSwatch(fragment);
        checkDensity();

        $body.trigger('search:updateProducts', { sortText: sortText.toLowerCase() });
    });
};

baseSearch.shopTheLookHandler = function () {
    $body.on('click', '.js-highlight-shop-the-look', function () {

        const parseBody = (html) => {
            const $html = $('<div>').append($.parseHTML(html));
            const body = $html.find('.custom-set-items');
            return body;
        };
        const highlightButon = this;
        const quickViewModal = queryFirst(`#productSetModal-${this.dataset.pid}`);
        const $quickViewModal = $(`#productSetModal-${this.dataset.pid} .modal-content`);
        const spinner = $quickViewModal.spinner();
        spinner.start();
        $.ajax({
            url: this.dataset.url,
            method: 'GET',
            success: function (response) {
                const parsedBody = parseBody(response.renderedTemplate);
                const modalBody = queryFirst('.modal-body', quickViewModal);
                if (modalBody.hasChildNodes()) {
                    modalBody.replaceChild(parsedBody[0], modalBody.firstChild);
                } else {
                    modalBody.appendChild(parsedBody[0]);
                }

                // update window.productInfo to set up selected size correctly
                updateProductInfoFromQuickViewInfo(response.quickviewProductInfo);

                const shopTheLookEl = queryFirst('.js-shop-the-look', quickViewModal);
                if (!shopTheLookEl) {
                    spinner.stop();
                    return;
                }

                // enable/disable addToCartButton
                enableAddAllToToteButton(shopTheLookEl);

                // select size if it is 'one-size' product AND hide 'select size' and 'edit' buttons
                let allProductsWithOneSize = true;
                queryAll('.js-size-selector', shopTheLookEl)?.forEach(element => {
                    const sizeElements = queryAll('.size-btn', element);
                    if (sizeElements && sizeElements.length === 1) {
                        sizeElements[0].click();
                        const jsAttr = sizeElements[0].closest('.js-attribute');
                        addClass([queryFirst('.js-select-size-btn', jsAttr), queryFirst('.js-edit-size-btn', jsAttr)], HIDDEN_CLASS);
                    } else {
                        allProductsWithOneSize = false;
                    }
                });

                if (allProductsWithOneSize) {
                    removeClass(queryFirst('.js-add-all-to-tote'), HIDDEN_CLASS);
                }

                // init events for select/edit size
                $(shopTheLookEl).on('click', '.js-select-size-btn, .js-edit-size-btn', function (e) {
                    const { target } = e;
                    const jsAttributeEl = target.closest('.js-attribute');
                    removeClass(queryFirst('.js-size-selector', jsAttributeEl), HIDDEN_CLASS);
                    addClass([this, queryFirst('.js-selected-size-block', jsAttributeEl)], HIDDEN_CLASS);
                });

                // init events for checkbox
                $(shopTheLookEl).on('click', '.js-select-size-input', function (e) {
                    const { target } = e;
                    const jsAttributeEl = target.closest('.js-attribute');
                    const productItem = target.closest('.js-set-item');
                    const jsSizeSelectorEl = queryFirst('.size-btn.selected', jsAttributeEl);

                    if (jsSizeSelectorEl) {
                        enableAddAllToToteButton(shopTheLookEl);
                    } else {
                        toggleSelectSizeInfo(productItem);
                        target.checked = false;
                    }
                });

                $body.trigger('search:shopTheLookUpdated', {
                    clickedElement: highlightButon
                });

                spinner.stop();
            },
            error: function () {
                spinner.stop();
            }
        });
    });
};
/**
 * Show more filer options if more then 10 options available
 */
baseSearch.showMoreFilters = function () {
    queryAll(showMoreRefinementClass)?.forEach(element => {
        if (!queryFirst(`li.${HIDDEN_CLASS}`, element.parentElement)) {
            addClass(element, HIDDEN_CLASS);
        }
    });
    $body.on('click', showMoreRefinementClass, function (e) {
        e.preventDefault();
        removeClass(queryAll(`li.${HIDDEN_CLASS}`, this.parentElement), HIDDEN_CLASS);
        addClass(this, HIDDEN_CLASS);
    });
};

/**
 * Check if container has selected density
 */
function checkDensity() {
    const selectedDensity = getCookieDensityValue();
    const actualDensityContainer = queryFirst('.js-product-grid');
    const densityPrefix = 'product-grid-';
    if (actualDensityContainer && !actualDensityContainer.classList.contains(`${densityPrefix}${selectedDensity}`)) {
        actualDensityContainer.classList.forEach(function (className) {
            if (className.startsWith(densityPrefix)) {
                // Replace the class with the new one
                actualDensityContainer.classList.replace(className, densityPrefix + selectedDensity);
            }
        });
        const densitySelectors = queryAll('.product-grid-view-button');
        densitySelectors.forEach((el) => {
            if (el.dataset.density === selectedDensity) {
                addClass(el, 'm-selected');
            } else {
                removeClass(el, 'm-selected');
            }
        });
    }
}

/**
 * Update product grid based on selected densety
 * Set selected densety to coolie
 */
baseSearch.densitySelector = function () {
    checkDensity();
    $body.on('click', '.product-grid-view-button', function (e) {
        e.preventDefault();
        isDensityButtonClicked = true;
        const densityElement = this;
        const selectedDensity = densityElement.dataset.density;
        setCookie('density', selectedDensity);
        const spinner = $.spinner();
        const densityUrl = setUrlParamValue(queryFirst('.ajax-density-url').value, 'density', selectedDensity);
        const densityContainers = queryAll('.product-grid-view');

        spinner.start();
        $.ajax({
            url: densityUrl,
            data: {
                selectedUrl: densityUrl
            },
            method: 'GET',
            success: function (response) {
                const fragment = renderFragment(response);

                updateUrlQueryParam(fragment);
                parseResults(fragment);
                updateSortOptions(fragment);
                showNoResultsText(fragment);
                updateCount(fragment);
                updateFilterCount(fragment);
                updatePatternImageSwatch(fragment);
                updatePatternImageSwatch(fragment);
                densityContainers.forEach(densityContainer => {
                    densityContainer.replaceWith(queryFirst('.product-grid-view', fragment));
                });
                addClass(densityElement, 'm-selected');
                $body.trigger('search:densityChange', {
                    density: selectedDensity
                });
                scrollTo(0, 0);
                spinner.stop();
            },
            error: function () {
                spinner.stop();
            }
        });
    });
};

baseSearch.focusTileOnBackButton = function () {
    const productGridContainer = queryFirst('.product-grid-container');
    let activeTileId = '';
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    /**
     * Update url
     */
    function unloadHandler() {
        if (!activeTileId) return;

        const url = new URL(window.location.href);
        url.hash = activeTileId;
        window.history.replaceState(window.location.href, '', url);
    }

    if (productGridContainer) {
        productGridContainer.addEventListener('click', (e) => {
            const productEl = e.target.closest('.product');
            if (productEl) {
                activeTileId = productEl.getAttribute('id') || '';
            }
        });
    }

    window.addEventListener('pagehide', unloadHandler);
};

/**
 * Scroll viewport to tile
 */
function scrollToTile() {
    if (!tileToScroll) return;

    // smooth will trigger unnecessary intersaction observer
    // use promises/setTimeout in observer with smooth param
    tileToScroll.scrollIntoView({ behavior: 'instant', block: 'start' });
    tileToScroll = null;
    const url = new URL(window.location.href);
    if (url.hash) {
        url.hash = '';
        window.history.replaceState(window.location.href, '', url);
    }
    $body.trigger('search:updateProducts');
}

/**
 * Update marketing slots markup
 */
function updateSlotsMarkup() {
    const elementsToMove = queryAll('.category-marketing-slot');
    const targetElement = queryFirst('.grid-footer'); // should select again as it was replaced

    [...elementsToMove].reverse().forEach(element => {
        targetElement.parentNode.insertBefore(element, targetElement);
    });
}

/**
 * Fetch all previous links
 * @param {string} url link to load products
 * @param {boolean} previous loaded to start
 */
function fetchUrls(url, previous) {
    loadProducts(url, {}, false, false, {}, previous);
}

baseSearch.loadPreviousProducts = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);
    const productTiles = document.querySelectorAll('.js-product-grid .product');
    let elementIndex = 1;
    if (url.hash) {
        tileToScroll = document.querySelector(`.js-product-grid ${url.hash}`);
        for (let i = 0; i < productTiles.length; i++) {
            if (productTiles[i] === tileToScroll) {
                elementIndex = i;
                break;
            }
        }
    }
    if (urlParams.has('start') && urlParams.get('start')) {
        let previous = false;
        let targetURL = '';
        let loadPageContainer;

        if (!url.hash) {
            tileToScroll = productTiles[0];
        }
        if (elementIndex < productTiles.length / 2) {
            loadPageContainer = queryFirst('.js-show-previous');
            previous = true;
        } else if (elementIndex >= productTiles.length / 2) {
            loadPageContainer = queryFirst('.show-more button');
        }
        targetURL = loadPageContainer?.dataset.url;

        if (targetURL) {
            preventObserver = true;
            fetchUrls(targetURL, previous);
        } else {
            scrollToTile();
        }
    } else {
        scrollToTile();
    }
};

module.exports = baseSearch;

/**
 * Adds class 'stuck' to filters bar
 */
baseSearch.filtersBarState = () => {
    let filtersBarStyles = null;
    let filtersBarTop = 0;

    function toggleFiltersBarState() {
        plpFiltersBar.forEach((el, index) => {
            if (!filtersBarStyles) {
                const filtersBarStyle = window.getComputedStyle(el);
                filtersBarTop = parseInt(filtersBarStyle.top, 10);
            }

            const currentTop = el.getBoundingClientRect().top;
            el.classList.toggle('stuck', currentTop <= filtersBarTop);
        });
    }

    window.addEventListener('scroll', throttle(toggleFiltersBarState, 50));
};

// Scroll to the selected refinement
baseSearch.filterPositionRestore = () => {
    const refinementId = queryFirst('[data-scroll-to-refinement]')?.dataset.scrollToRefinement;
    if (!refinementId) return;
    const container = queryFirst('.refinement-menu');
    const child = queryFirst(`.refinement-${refinementId}`);

    const containerTop = container.getBoundingClientRect().top;
    const childTop = child.getBoundingClientRect().top;

    const offset = childTop - containerTop + container.scrollTop;

    container.scrollTo({ top: offset, behavior: 'instant' });
};
